import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const saleApi = {
  // lay danh sach
  getSaleList: (params) => {
    const url = '/sale';
    return axiosClient.get(url, { params: Utils.filterParams(params) });
  },

  // them
  createSale: (params) => {
    const url = '/sale/create';
    return axiosClient.post(url, params);
  },

  // cap nhat don hang
  updateSale: (id, params) => {
    const url = `/sale/${id}`;
    return axiosClient.put(url, params);
  },

  // xem truoc hoa don dien tu cua don hang san pham (khong phat hanh)
  previewSaleInvoice: (id) => {
    const url = `/sale/${id}/invoice`;
    return axiosClient.get(url);
  },

  // phat hanh hoa don dien tu cho don hang san pham da thanh toan
  createSaleInvoice: (id) => {
    const url = `/sale/${id}/invoice`;
    return axiosClient.post(url);
  },
};

export default saleApi;
